<template>
  <v-col lg="2" xl="2">
    <v-card class="ad-card-collapsed pa-3" elevation="0" @click="openUrl">
      <v-card-title class="justify-end mt-n7 mb-n3">
        <div class="badge">AD</div>
      </v-card-title>
      <v-card-text>
        <h3 class="ad-title">{{ ad.title }}</h3>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "SingleCardAd",
  props: {
    ad: Object,
  },
  methods: {
    openUrl() {
      window.open(this.ad.ctaUrl);
    },
  }
}
</script>

<style scoped>

</style>
